// extracted by mini-css-extract-plugin
module.exports = {"table-header":"styles_table-header__1O1bn","table-header__cell":"styles_table-header__cell__2PFYF","table-header__icon":"styles_table-header__icon__LMNay"};